export type SectorCard = {
  slug: string;
  title: string;
  searchKeyword: string;
  industryCategory: string;
  subcategories: string[];
};

export const HOME_SECTOR_CARDS: SectorCard[] = [
  {
    slug: "energy-utilities",
    title: "Energy & Utilities",
    searchKeyword: "Power & Energy",
    industryCategory: "POWER_AND_ENERGY",
    subcategories: ["Oil & Gas", "Power & Energy (Conventional & Renewables)"],
  },
  {
    slug: "industrial-manufacturing",
    title: "Industrial & Manufacturing",
    searchKeyword: "Manufacturing & Industrial Automation",
    industryCategory: "MANUFACTURING_AND_INDUSTRIAL_AUTOMATION",
    subcategories: [
      "Manufacturing & Industrial Automation",
      "Chemicals & Specialty Materials",
      "Metals & Minerals",
    ],
  },
  {
    slug: "mobility-aerospace-defence",
    title: "Mobility, Aerospace & Defence",
    searchKeyword: "Defence & Aerospace",
    industryCategory: "DEFENCE_AND_AEROSPACE",
    subcategories: ["Automotive & EV Ecosystem", "Defence & Aerospace", "Shipping, Maritime & Ports"],
  },
  {
    slug: "infrastructure-built-environment",
    title: "Infrastructure & Built Environment",
    searchKeyword: "Construction & EPC",
    industryCategory: "CONSTRUCTION_AND_EPC",
    subcategories: ["Construction", "Infrastructure & EPC"],
  },
  {
    slug: "technology-electronics",
    title: "Technology & Electronics",
    searchKeyword: "Electronics & Semiconductors",
    industryCategory: "ELECTRONICS_AND_SEMICONDUCTORS",
    subcategories: ["ICT", "Software, API & Digital Technologies", "Electronics & Semiconductors"],
  },
  {
    slug: "environment-sustainability",
    title: "Environment & Sustainability",
    searchKeyword: "Climate Tech & Sustainability",
    industryCategory: "CLIMATE_TECH_AND_SUSTAINABILITY",
    subcategories: [
      "Water & Wastewater",
      "Environmental Solutions",
      "Climate Tech, Carbon Management & Sustainability Solutions",
    ],
  },
  {
    slug: "agriculture-food-systems",
    title: "Agriculture & Food Systems",
    searchKeyword: "Agriculture & Food Processing",
    industryCategory: "AGRICULTURE_AND_FOOD_PROCESSING",
    subcategories: ["Agriculture, Agritech & Food Processing"],
  },
  {
    slug: "healthcare-life-sciences",
    title: "Healthcare & Life Sciences",
    searchKeyword: "Healthcare & Life Sciences",
    industryCategory: "HEALTHCARE_AND_LIFE_SCIENCES",
    subcategories: ["Healthcare", "MedTech & Life Sciences"],
  },
];

export function getSectorBySlug(slug: string | undefined): SectorCard | null {
  if (!slug) return null;
  return HOME_SECTOR_CARDS.find((sector) => sector.slug === slug) ?? null;
}
